"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultScale;

var d3Scale = _interopRequireWildcard(require("d3-scale"));

var _ChartData = _interopRequireDefault(require("../chartdata/ChartData"));

var _definitions = require("../definitions");

// create a set of booleans to check if a group is mixing dimension types
function isContinuous(columns, data) {
  return columns.map(function (columnName) {
    var column = data.columns.find(function (ii) {
      return ii.key === columnName;
    });
    return !!column && column.isContinuous;
  });
}

function isDate(columns, data) {
  return columns.map(function (columnName) {
    var row = data.rows[0];
    if (!row) return false;
    return _ChartData.default.isValueDate(row[columnName]);
  });
}

function defaultScale(scaleProps) {
  var primitiveDimension = scaleProps.primitiveDimension,
      columns = scaleProps.columns,
      scaleType = scaleProps.scaleType,
      primitiveDimensionProps = scaleProps.primitiveDimensionProps,
      data = scaleProps.data; // are any of the columns continuous.

  var continuous = isContinuous(columns, data).includes(true);
  var time = isDate(columns, data).includes(true);
  var scaleName = scaleType || (time ? 'scaleTime' : continuous ? 'scaleLinear' : 'scaleBand'); // if the size is greater than one we have multiple data types

  if (new Set(isContinuous(columns, data)).size > 1) {
    throw new Error("A scale cannot share continuous and non continuous data: ".concat(columns.join(', ')));
  }

  var domainArray = continuous // the domain of continuous data can be a plain min max of columns
  ? [time ? data.min(columns) : 0, data.max(columns)] // the domain of non-continuous data has to be an array of all unique values of columns
  : data.getUniqueValues(columns);

  switch (primitiveDimension) {
    case 'x':
    case 'y':
      // choose the max value of range based on x/width y/height
      var bound = primitiveDimension === 'x' ? primitiveDimensionProps.width : primitiveDimensionProps.height;
      return d3Scale[scaleName]().domain(domainArray).range([0, bound]);

    default:
      return d3Scale[scaleName]().domain(domainArray);
  }
}